import type { ReactNode } from "react";
import { usePermission } from "@/context/PermissionContext";
import { AccessDeniedPage } from "@/components/ui/ErrorPage";

interface RoutePermissionGuardProps {
  module: string;
  moduleName?: string;
  children: ReactNode;
}

export function RoutePermissionGuard({ module, moduleName, children }: RoutePermissionGuardProps) {
  const { canView, isSuperAdmin } = usePermission();

  if (!isSuperAdmin && !canView(module)) {
    return <AccessDeniedPage moduleName={moduleName || module} />;
  }

  return <>{children}</>;
}

export default RoutePermissionGuard;
